<script>
import PainelServidor from '@/components/painel/PainelServidor.vue'

export default {
  extends: PainelServidor,
}
</script>
